<template>
  <div class="h-full w-full overflow-hidden">
    <ColumnHeader
      v-show="data.showTitle"
      :title="title"
      @loadMore="loadMore"
      :showMore="data.showMore && !specialSource.includes(data.dataSource)"
    />
    <div :class="getBodyClass()" class="news-list">
      <div
        v-for="(it, index) in list"
        :key="index"
        class="flex items-center mt-12px float-left"
        :class="{
          'mr-20px': (index + 1) % col !== 0,
        }"
        :style="{
          width: `calc(100% / ${col} - 20px * ${col - 1} / ${col})`,
        }"
      >
        <div v-show="data.showDate" class="p-5px bg-hex-$portalPrimaryBgColor w-55px simSun">
          <p class="text-14px text-hex-$portalPrimaryColor text-center">
            {{ dayjs(it.editPublishTime).format('MM/DD') }}
          </p>
          <p class="text-10px text-hex-000 text-center mt-10px">
            {{ dayjs(it.editPublishTime).format('YYYY') }}年
          </p>
        </div>
        <div class="w-[calc(100%-55px)] pl-10px cursor-pointer" @click="liClick(it)">
          <div class="flex items-center mb-10px">
            <div
              v-show="!data.showDate"
              class="bg-$portalPrimaryColor w-6px h-6px rounded-1/2 mr-10px"
            ></div>
            <p
              :class="getTitleStyle(it)"
              :title="it.title"
              :style="{
                color: it.titleStyle ? it.titleStyle.color : null,
                fontWeight: it.titleStyle && it.titleStyle.fontWeight ? 'bold' : null,
              }"
            >
              {{ it.title }}
            </p>
          </div>
          <div v-show="data.showContent">
            <p
              v-show="!data.showDate"
              class="text-15px text-hex-000 truncate pl-16px !leading-17px simSun"
            >
              {{ it.summary }}
            </p>
            <p v-show="data.showDate" class="text-15px text-hex-000 truncate !leading-17px simSun">
              {{ it.summary }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right mt-10px" v-show="data.showPagination">
      <el-pagination
        small
        background
        @current-change="tableCurrentChange"
        :current-page.sync="page.pageNo"
        layout="total, prev, pager, next"
        :page-size.sync="page.pageSize"
        :total="page.totalCount"
        :pager-count="5"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { ColumnTableSearchApi, ColumApi } from '@wiz-api/workbench'
import dayjs from 'dayjs'
import addRequestQueue from '@/assets/js/RequestQueue'
import ColumnHeader from './ColumnHeader'

const columnTableSearch = new ColumnTableSearchApi()
const columApi = new ColumApi()

export default {
  name: 'NewsOne',
  components: { ColumnHeader },
  props: {
    data: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'update', // update/view   update模式不触发点击
    },
    height: {
      type: String,
      default: 'fixed',
    },
  },
  data() {
    return {
      list: [],
      title: '列表',
      dataSource: '',
      page: {
        pageNo: 1,
        pageSize: 1,
        totalCount: 0,
      },
      row: 5,
      col: 1,
      specialSource: [
        '11111111-1111-1111-1111-111111111111',
        '22222222-2222-2222-2222-222222222222',
      ],
    }
  },
  methods: {
    getTitleStyle() {
      const className =
        'text-hex-000 truncate w-[calc(100%-6px)] hover:text-hex-$portalPrimaryColor'
      if (this.data.showContent) {
        return `${className} text-16px !leading-20px`
      }
      return `${className} text-15px !leading-17px simSun`
    },
    tableCurrentChange(value) {
      this.page.pageNo = value
      if (this.data.dataSource === '11111111-1111-1111-1111-111111111111') {
        this.getHotListData()
      } else {
        this.getListData()
      }
    },
    loadMore() {
      if (this.mode !== 'update') {
        window.open(
          `${window.location.origin}${window.location.hash ? '/#' : ''}${
            this.routerBase
          }/portal/homepage?columnId=${this.data.dataSource}`
        )
      }
    },
    liClick(item) {
      if (this.mode !== 'update') {
        if (item.externalLink) {
          window.open(item.externalLink)
        } else {
          window.open(
            `${window.location.origin}${window.location.hash ? '/#' : ''}${
              this.routerBase
            }/portal/ColumnDetail?id=${item.id}&type=${item.type}`
          )
        }
      }
    },
    getBodyClass() {
      if (this.height === 'auto') {
        return 'h-auto clearfix'
      }
      if (this.data.showTitle) {
        if (this.data.showPagination) {
          return 'h-[calc(100%-78px)] overflow-y-auto'
        }
        return 'h-[calc(100%-38px)] overflow-y-auto'
      }
      if (this.data.showPagination) {
        return 'h-[calc(100%-38px)] overflow-y-auto'
      }
      return 'h-full overflow-y-auto'
    },
    async getListData() {
      let params = {}
      if (this.data.dataSource === '22222222-2222-2222-2222-222222222222') {
        params = {
          columnId: this.data.columnId,
          ignoreId: this.data.columnTableId,
        }
      } else {
        params = {
          columnId: this.data.dataSource,
        }
      }
      const [err, res] = await addRequestQueue(() => {
        return columnTableSearch.searchColumnTable(this.page.pageNo, this.page.pageSize, params)
      })
      if (!err) {
        this.list = _.map(res.items, (item) => {
          item.titleStyle = item.titleStyle ? JSON.parse(item.titleStyle) : null
          return item
        })
        this.page.totalCount = res.totalCount
        this.$nextTick(() => {
          this.$emit('nextTick')
        })
      }
    },
    async getHotListData() {
      const [err, res] = await addRequestQueue(() => {
        return columnTableSearch.getHotColumnTable(this.page.pageNo, this.page.pageSize, {
          hotStartTime: dayjs()
            .subtract(7, 'days')
            .format('YYYY-MM-DD HH:mm:ss'),
          hotEndTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        })
      })
      if (!err) {
        this.list = _.map(res.items, (item) => {
          item.titleStyle = item.titleStyle ? JSON.parse(item.titleStyle) : null
          return item
        })
        this.page.totalCount = res.totalCount
        this.$nextTick(() => {
          this.$emit('nextTick')
        })
      }
    },
    async getTitle() {
      if (this.data.title && this.data.dataSource) {
        this.getListData()
        return
      }
      if (this.data.dataSource !== '' && this.data.dataSource != null) {
        const [err, res] = await columApi.getColumnDetail(this.data.dataSource)
        if (!err) {
          this.title = res.name
          this.getListData()
        }
      }
    },
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.row = val.row || 5
          this.col = val.col || 1
          if (val.title) this.title = val.title
          if (val.dataSource !== this.dataSource || this.col * this.row !== this.page.pageSize) {
            this.page.pageSize = this.col * this.row
            this.dataSource = val.dataSource
            switch (val.dataSource) {
              case '11111111-1111-1111-1111-111111111111':
                this.title = '本周热门排行'
                this.getHotListData()
                break
              case '22222222-2222-2222-2222-222222222222':
                this.title = '相关推荐'
                this.getListData()
                break
              default:
                this.getTitle()
                break
            }
          }
        }
      },
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.clearfix {
  *zoom: 1;
  &::after {
    content: '';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
}
.simSun {
  font-family: 'SimSun';
}
</style>
